import { SecretValue } from "client/Api/Apps/common";
import { environmentHttpClient } from "../httpClient";

export type EgnyteConnectionListItemModel = {
	id: number;
	name: string;
	domainName: string;
};

export function list(
	signal?: AbortSignal
): Promise<readonly EgnyteConnectionListItemModel[]> {
	return environmentHttpClient.get<readonly EgnyteConnectionListItemModel[]>(
		"UiApi/EgnyteConfiguration/List",
		undefined,
		{ signal }
	);
}

export type EgnyteConnectionModel = {
	id: number;
	name: string;
	domainName: string;
	clientId: string;
};

export function get(
	id: number,
	signal?: AbortSignal
): Promise<EgnyteConnectionModel> {
	return environmentHttpClient.get<EgnyteConnectionModel>(
		`UiApi/EgnyteConfiguration/${id}`,
		undefined,
		{ signal }
	);
}

export type EgnyteConnectionSaveModel = {
	name: string;
	domainName: string;
	clientId: string;
	clientSecret: SecretValue;
};

export type SavedSuccessfullyResult = {
	id: number;
};

export type AuthenticationRequiredResult = {
	redirectUrl: string;
};

export function create(
	model: EgnyteConnectionSaveModel,
	signal?: AbortSignal
): Promise<SavedSuccessfullyResult> {
	return environmentHttpClient.post<SavedSuccessfullyResult>(
		"UiApi/EgnyteConfiguration",
		model,
		{ signal }
	);
}

export function update(
	id: number,
	model: EgnyteConnectionSaveModel,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.put<void>(
		`UiApi/EgnyteConfiguration/${id}`,
		model,
		{ signal }
	);
}

export function deleteConnections(
	ids: readonly number[],
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.delete<void>(
		"UiApi/EgnyteConfiguration",
		ids,
		{ signal }
	);
}
